import type { Template } from "@/types";

export const SQ_06_H3_V3: Template[] = [
    {
        id: "sq-06-h3v3-01",
        name: "SQ 01 - H3V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h3_v3_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 49, y: 93, width: 258, height: 171, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 272, width: 258, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 49, y: 451, width: 258, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 315, y: 93, width: 352, height: 530, rotation: 0, imageRotation: 0 },
            { id: "5", x: 766, y: 93, width: 306, height: 530, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 93, width: 305, height: 530, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h3v3-02",
        name: "SQ 02 - H3V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h3_v3_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 49, y: 49, width: 408, height: 619, rotation: 0, imageRotation: 0 },
            { id: "2", x: 465, y: 49, width: 203, height: 305, rotation: 0, imageRotation: 0 },
            { id: "3", x: 465, y: 362, width: 203, height: 306, rotation: 0, imageRotation: 0 },
            { id: "4", x: 766, y: 49, width: 619, height: 412, rotation: 0, imageRotation: 0 },
            { id: "5", x: 766, y: 469, width: 306, height: 199, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 469, width: 305, height: 199, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h3v3-03",
        name: "SQ 03 - H3V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h3_v3_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 49, y: 49, width: 619, height: 412, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 469, width: 306, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 469, width: 305, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 766, y: 49, width: 408, height: 619, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1182, y: 49, width: 203, height: 305, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1182, y: 362, width: 203, height: 306, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h3v3-04",
        name: "SQ 04 - H3V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h3_v3_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 49, y: 49, width: 619, height: 412, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 469, width: 306, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 469, width: 305, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 862, y: 145, width: 279, height: 427, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1149, y: 145, width: 140, height: 209, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1149, y: 362, width: 140, height: 210, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h3v3-05",
        name: "SQ 05 - H3V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h3_v3_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 69, y: 71, width: 281, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 69, y: 265, width: 281, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 69, y: 459, width: 281, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 358, y: 71, width: 290, height: 574, rotation: 0, imageRotation: 0 },
            { id: "5", x: 786, y: 145, width: 286, height: 427, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 145, width: 285, height: 427, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h3v3-06",
        name: "SQ 06 - H3V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h3_v3_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 69, y: 71, width: 441, height: 283, rotation: 0, imageRotation: 0 },
            { id: "2", x: 69, y: 362, width: 441, height: 283, rotation: 0, imageRotation: 0 },
            { id: "3", x: 786, y: 145, width: 579, height: 427, rotation: 0, imageRotation: 0 },
            { id: "4", x: 518, y: 71, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 518, y: 265, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 518, y: 459, width: 130, height: 186, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h3v3-07",
        name: "SQ 07 - H3V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h3_v3_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 69, y: 71, width: 286, height: 438, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 71, width: 285, height: 438, rotation: 0, imageRotation: 0 },
            { id: "3", x: 69, y: 517, width: 188, height: 128, rotation: 0, imageRotation: 0 },
            { id: "4", x: 265, y: 517, width: 188, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 461, y: 517, width: 187, height: 128, rotation: 0, imageRotation: 0 },
            { id: "6", x: 884, y: 71, width: 385, height: 574, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-06-h3v3-08",
        name: "SQ 08 - H3V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h3_v3_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 49, y: 94, width: 351, height: 529, rotation: 0, imageRotation: 0 },
            { id: "2", x: 408, y: 94, width: 351, height: 529, rotation: 0, imageRotation: 0 },
            { id: "3", x: 767, y: 94, width: 351, height: 529, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1126, y: 94, width: 259, height: 171, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1126, y: 273, width: 259, height: 171, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1126, y: 452, width: 259, height: 171, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h3v3-09",
        name: "SQ 09 - H3V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h3_v3_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 40, y: 151, width: 136, height: 204, rotation: 0, imageRotation: 0 },
            { id: "2", x: 40, y: 363, width: 304, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 184, y: 151, width: 304, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 352, y: 363, width: 136, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 496, y: 151, width: 618, height: 415, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1122, y: 151, width: 272, height: 415, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h3v3-10",
        name: "SQ 10 - H3V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h3_v3_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 137, width: 136, height: 218, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 363, width: 136, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 144, y: 137, width: 666, height: 444, rotation: 0, imageRotation: 0 },
            { id: "4", x: 818, y: 137, width: 298, height: 444, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1124, y: 137, width: 310, height: 218, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1124, y: 363, width: 310, height: 218, rotation: 0, imageRotation: 0 }
        ],
    },
];

